import {
    IonButton,
    IonButtons,
    IonCard,
    IonCardContent,
    IonCardHeader,
    IonCardTitle,
    IonContent,
    IonHeader,
    IonIcon,
    IonImg,
    IonLabel,
    IonModal,
    IonTitle,
    IonToolbar,
} from "@ionic/react";
import { Answer } from "frontend-lib/DomainTypes/KnowledgeRecord";
import React, { useRef } from "react";
import { documentTextOutline } from "ionicons/icons";
import { useTranslation } from "react-i18next";

interface Props {
    isOpen: boolean;
    onCloseCb: () => {};
    answer?: Answer;
    sendKr: (krId: number) => void;
}

export default function KnowledgeRecordView({ isOpen, onCloseCb, answer, sendKr }: Props) {
    const { t } = useTranslation();
    const modalRef = useRef<HTMLIonModalElement>(null);

    const renderImageVideo = () => {
        if (!answer?.attachments || answer.attachments.length === 0) return <></>;
        const mediaTags: Array<React.JSX.Element> = answer.attachments.map((att) => {
            switch (att.attachmentType) {
                case "IMAGE":
                    return <IonImg src={att.link} alt="" />;
                case "VIDEO":
                    return (
                        <video controls>
                            <source src={att.link}></source>
                        </video>
                    );
                default:
                    return <></>;
            }
        });
        return (
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                {mediaTags}
            </div>
        );
    };

    const renderOtherMedia = () => {
        if (!answer?.attachments || answer.attachments.length === 0) return <></>;
        const mediaTags: Array<React.JSX.Element> = answer.attachments
            .filter((att) => !["IMAGE", "VIDEO"].includes(att.attachmentType))
            .map((att) => {
                switch (att.attachmentType) {
                    case "AUDIO":
                        return (
                            <IonCardContent>
                                <audio controls>
                                    <source src={att.link} />
                                </audio>
                            </IonCardContent>
                        );
                    default:
                        return (
                            <IonCardContent>
                                <IonIcon icon={documentTextOutline} size="medium" />
                                <IonLabel>
                                    <a href={att.link}>Clik to see</a>
                                </IonLabel>
                            </IonCardContent>
                        );
                }
            });
        return <>{mediaTags}</>;
    };

    return (
        <IonModal isOpen={isOpen} ref={modalRef}>
            <IonHeader>
                <IonToolbar>
                    <IonTitle>{t("prediction")}</IonTitle>
                    <IonButtons slot="start">
                        <IonButton onClick={onCloseCb}>{t("close")}</IonButton>
                    </IonButtons>
                    <IonButtons slot="end">
                        <IonButton onClick={() => answer && sendKr(answer.sourceId)}>{t("send")}</IonButton>
                    </IonButtons>
                </IonToolbar>
            </IonHeader>

            <IonContent>
                <IonCard>
                    {renderImageVideo()}
                    <IonCardHeader>
                        <IonCardTitle>{answer?.knowledgeRecord.title}</IonCardTitle>
                    </IonCardHeader>
                    <IonCardContent style={{ whiteSpace: "pre-line" }}>
                        {answer?.answer}
                    </IonCardContent>
                    {renderOtherMedia()}
                </IonCard>
            </IonContent>
        </IonModal>
    );
}
